import { render, staticRenderFns } from "./SectionHistoryService.vue?vue&type=template&id=539bc216&scoped=true"
import script from "./SectionHistoryService.vue?vue&type=script&lang=js"
export * from "./SectionHistoryService.vue?vue&type=script&lang=js"
import style0 from "./SectionHistoryService.vue?vue&type=style&index=0&id=539bc216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539bc216",
  null
  
)

export default component.exports